export const masks = {
  date: '##/##/####',
  phone: '(###) ###-####',
  creditCard: '#### #### #### ####',
  zipCode: '#####'
}
